export default __webpack_public_path__ + "static/media/efficient.a7bf3f9d.svg";